import script from "./RunBoard.vue?vue&type=script&setup=true&lang=ts"
export * from "./RunBoard.vue?vue&type=script&setup=true&lang=ts"

import "./RunBoard.vue?vue&type=style&index=0&id=0b66d77e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b66d77e"]])

export default __exports__